import { createSlice } from '@reduxjs/toolkit';

const getDefaultTheme = () => {
  const storedTheme = localStorage.getItem('theme');
  return storedTheme || 'mytheme';
};

interface ThemeState {
  theme: string;
  systemThemeActivated: boolean;
}

const initialState: ThemeState = {
  theme: getDefaultTheme(),
  systemThemeActivated: localStorage.getItem('systemThemeActivated') === 'true' || false,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setLightTheme: (state) => {
      state.theme = 'mytheme';
      localStorage.setItem('theme', 'mytheme');
      localStorage.removeItem('systemThemeActivated');
      state.systemThemeActivated = false;
    },
    setDarkTheme: (state) => {
      state.theme = 'dark';
      localStorage.setItem('theme', 'dark');
      localStorage.removeItem('systemThemeActivated');
      state.systemThemeActivated = false;
    },
    toggleSystemTheme: (state) => {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      state.theme = prefersDark ? 'dark' : 'mytheme';
      localStorage.setItem('theme', state.theme);
      localStorage.setItem('systemThemeActivated', 'true');
      state.systemThemeActivated = true;
    },
    setSystemTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem('theme', state.theme);
    },
  },
});

export const { setLightTheme, setDarkTheme, toggleSystemTheme, setSystemTheme } = themeSlice.actions;
export default themeSlice.reducer;
